var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import apiClient from '@utils/api-client';
import { BULK_UPDATE_ACTION_FILE_ACCESS } from '../constants';
const basePath = (invoiceId) => `/api/internal/invoices/${invoiceId}/attachments`;
/**
 * Fetches every attachment on an invoice in one request. Not paginated; if it ever becomes so,
 * this call must opt out explicitly rather than silently rendering a truncated page.
 *
 * Discards the envelope's `readOnly`: the surface takes the invoice lock as a prop, rendered from
 * the same `attachment_actions_disabled?` helper, so it is known before the first fetch resolves
 * and the Add button never appears only to vanish. See `InvoiceAttachmentsSurfaceProps#readOnly`.
 */
export function fetchInvoiceAttachments(invoiceId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.get(basePath(invoiceId));
        return response.data.attachments;
    });
}
/** Single-field partial payload, returning the server-confirmed row. */
export function updateInvoiceAttachment(invoiceId, attachmentId, payload) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.patch(`${basePath(invoiceId)}/${attachmentId}`, {
            invoiceAttachment: payload
        });
        return response.data.attachment;
    });
}
/** Mass "Update visibility". Only the named rows are written. */
export function bulkUpdateFileAccess(invoiceId, ids, fileAccess) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.patch(`${basePath(invoiceId)}/bulk_update`, {
            ids,
            updateAction: BULK_UPDATE_ACTION_FILE_ACCESS,
            fileAccess
        });
        return response.data;
    });
}
/**
 * Mass destroy. Always sends explicit ids: this endpoint treats absent AND empty as "no rows", so
 * a cleared selection can never delete every attachment on the invoice.
 */
export function bulkDestroyAttachments(invoiceId, ids) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.delete(`${basePath(invoiceId)}/bulk_destroy`, {
            data: { ids }
        });
        return response.data;
    });
}
/**
 * Single-row destroy. Removes the S3 object for a direct-upload row; a legacy row's bytes are
 * CarrierWave's and go with the record's own `before_destroy`.
 */
export function destroyAttachment(invoiceId, attachmentId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield apiClient.delete(`${basePath(invoiceId)}/${attachmentId}`);
    });
}
